// extracted by mini-css-extract-plugin
export default {"review":"review_review__znEGN","message":"review_message__FMKOC","title":"review_title__eHxQK","readMore":"review_readMore__bshxc","author":"review_author__BLDgR"};